import { createAction, props } from '@ngrx/store';

export const loadStrategyList = createAction('[Strategy] Load List');

export const loadStrategyListSuccess = createAction(
  '[Strategy] Load List Success',
  props<{ data: any[] }>()
);

export const loadStrategyListFailure = createAction(
  '[Strategy] Load List Failure',
  props<{ error: any }>()
);

export const clearStrategyList = createAction('[Strategy] Clear List');
